module.exports = __webpack_public_path__ + "sort_desc.033d25badaac278d67e2.png";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/images/sort_desc.png
// module id = ../../../../../src/assets/images/sort_desc.png
// module chunks = main